/* global $, d3 */

export function getGraphWidth(containerWidth, sectionColumnWidth, bp) {
  // For screens < mobile, set svg to containerWidth
  if (containerWidth <= bp) {
    return containerWidth - 18;
  } else {
    return containerWidth - sectionColumnWidth - 18;
  }
}

export function graphTransition(grid, svg, shapes) {

  var delayScale = d3.scale.linear().domain([0, 400]).range([0, 300]);
  // This line will adjust height of SVG to match data
  svg.attr('height', grid.height());
  shapes.transition()
    .duration(750)
    .delay(function (d) { return delayScale(d.groupIndex * 150 + d.index * 1); })
    .attr('transform', function (d) { return 'translate(' + d.x + ',' + d.y + ')'; });
}

export function updateLabels(grid, svg, group) {
  var groups = grid.groups();

  // Provide d3 a key function so that labels are animated correctly
  // http://bost.ocks.org/mike/constancy/

  var labels = svg.selectAll('text').data(groups, function (d) {
    return d.name;
  });

  var labelGroup;

  $.getJSON(CONFIG.projectPath + 'assets/data/labels.json', function(json) {
      for (var key in json) {
        if (key === group) {
          labelGroup = json[key];
        }
      }

  labels.enter()
    .append('text')
      .attr('y', function (d) { return d.y; })
      .style('opacity', 0);
  labels.exit()
      .transition()
      .style('opacity', 0)
    .remove();

  labels.text(function (d) {
      var label;

      for (var prop in labelGroup) {
        if (prop === d.name) {
          label = labelGroup[prop];
        }
      }

      return label + ' (' + d.data.length + ')';

    }).attr('class', 'graph__group--label')
    .transition()
      .duration(750)
      .attr('x', 0)
      .attr('y', function (d) { return d.y; })
      .style('opacity', 1);

  });
}



/** WEBPACK FOOTER **
 ** ./includes/gridUtils.js
 **/